import React from 'react'
import { useProfileStore } from '../../store/useUserStore';
import { toast } from 'react-toastify';

type Props = {
    branch_id: number;
    name: string;
    images?: string[];
    saveBranchAndNavigate: (branchId: number) => void,
    isFull: boolean
}

const BranchCard: React.FC<Props> = ({ branch_id, name , images, saveBranchAndNavigate, isFull }) => {
    const { setSelectedBranchName } = useProfileStore()

    return (
    <div className="rounded-xl mb-8 shadow-course-card" onClick={()=>{
        if (!branch_id) {
            return toast.error("Branch ID not found. Please contact administrator.")
        } else {
            setSelectedBranchName(name)
            saveBranchAndNavigate(branch_id)
        }
    }}>
        <div className="text-center mb-1">
            <div>
                {images && images.length > 0 ? (
                    <img style={{ height: "10rem" }} className="img-fluid rounded-tl-lg rounded-tr-lg inline-block" alt="" src={images[0]}/>
                ):(
                    <img style={{ height: "10rem" }} className="img-fluid rounded-tl-lg rounded-tr-lg inline-block" alt="" src="/assets/img/products/product1.png"/>
                )}
            </div>
        </div>
        <div className={`px-2 pb-2`}>
            <div className="flex justify-between items-start gap-2 min-h-[2.5em] pt-0.5">
                <div className="font-semibold text-base line-clamp-2 overflow-hidden text-ellipsis" title={name}>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default BranchCard